import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import moment from "moment";
import CustomCheckbox from "components/custom/forms/custom-checkbox";

class TabWorkerScheduledWork extends React.Component {
    render () {
        let scheduledWork = this.props.getEmployeeValue(this.props.tabKey);
        if (!scheduledWork || !Object.keys(scheduledWork).length) {
            scheduledWork = [];
        }

        const columns = [
            {
                Header: "Retailer",
                accessor: "retailer",
                id: "retailer"
            },
            {
                Header: "Store#",
                accessor: "storeNumber",
                id: "storeNumber"
            },
            {
                Header: "Job Code",
                accessor: "jobNumber",
                id: "jobNumber",
                headerClassName: "text-left"
            },
            {
                Header: "Start Date",
                accessor: original => moment(original.startDate),
                id: "startDate",
                Cell: ({ original }) => (original.startDate !== ""
                    ? moment(original.startDate).format("YYYY-MM-DD")
                    : null),
                headerClassName: "text-left"
            },
            {
                Header: "End Date",
                accessor: original => moment(original.endDate),
                id: "endDate",
                Cell: ({ original }) => (original.endDate !== ""
                    ? moment(original.endDate).format("YYYY-MM-DD")
                    : null),
                headerClassName: "text-left"
            },
            {
                Header: "Hours",
                accessor: "hours",
                id: "hours",
                headerClassName: "text-left"
            },
            {
                Header: "Scheduled",
                accessor: "scheduled",
                id: "scheduled",
                Cell: ({ original }) => (
                    <CustomCheckbox
                        key={original.id}
                        className="checkbox"
                        checked={original.isSchedule}
                        readOnly={true}
                    />
                ),
                headerClassName: "text-left"
            }
        ];

        return (
            <div className="container mt-3">
                <ReactTable
                    data={scheduledWork}
                    columns={columns}
                    defaultPageSize={10}
                    NoDataComponent={() => null}
                    headerClassName="table-header"
                    className="-striped -highlight"
                />
            </div>
        );
    }
}

TabWorkerScheduledWork.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
};

export default TabWorkerScheduledWork;
